module.exports = __webpack_public_path__ + "img/RAINBET.0e78f864.svg";